import { render, staticRenderFns } from "./EmployeeRecruitment.vue?vue&type=template&id=63d4f793&scoped=true"
import script from "./EmployeeRecruitment.vue?vue&type=script&lang=js"
export * from "./EmployeeRecruitment.vue?vue&type=script&lang=js"
import style0 from "./EmployeeRecruitment.vue?vue&type=style&index=0&id=63d4f793&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d4f793",
  null
  
)

export default component.exports